module.exports = __webpack_public_path__ + "media/images/features/6/schedule-7-687b6a0fe75f9cb269a6a1f78c8add7f.png";